if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.usesLegacyCartSections = !document.getElementById('cart-drawer-react-entry');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton)
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // This approach works, but it is not ideal.  It might be possible to refactor this solution if we update the ReCharge PDP widget from the Legacy Widget to their new Subscription Widget
        let main_form_selling_plan = document.querySelector('product-info .form input[name=selling_plan]');
        if (main_form_selling_plan) {
          let current_form_has_selling_plan = this.querySelector('form input[name=selling_plan]');
          if (!current_form_has_selling_plan) {
            this.querySelector('form').appendChild(main_form_selling_plan.cloneNode());
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const recForm = document.querySelector('recipient-form');
        if (recForm) {
          recForm.querySelectorAll('input[name^="properties"], textarea[name^="properties"]').forEach(src => {
            if (src.type === 'checkbox' && !src.checked) return;
            formData.append(src.name, src.value);
          });
        }

        const designInput = this.form.querySelector('input[name="properties[Design]"]');
        if (designInput && designInput.value) {
          formData.append(designInput.name, designInput.value);
        }

        let srcCode = localStorage.getItem('srcCode');
        let srcCodeTwo = localStorage.getItem('src');
        if (srcCodeTwo && (!srcCode || srcCode === '')) {
          srcCode = srcCodeTwo;
        }
        let anonymousID = null;
        // 1) Prefer Segment's in-memory identity
        try {
          if (window.analytics && typeof window.analytics.user === 'function') {
            const segUser = window.analytics.user();
            if (segUser && typeof segUser.anonymousId === 'function') {
              anonymousID = segUser.anonymousId();
            }
          }
        } catch (e) {
          console.warn('Error getting Segment anonymousId from window.analytics', e);
        }
        // 2) Fallback to localStorage if in-memory isn't available
        if (!anonymousID) {
          anonymousID = localStorage.getItem('ajs_anonymous_id');
          if (anonymousID && anonymousID.startsWith('"') && anonymousID.endsWith('"')) {
            anonymousID = anonymousID.slice(1, -1);
          }
        }
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const userAgent = navigator.userAgent;
        const analyticsSessionId = localStorage.getItem('analytics_session_id') || '';
        const referrer = localStorage.getItem('shopify_referrer') || null;
        const shopifyCustomerId = localStorage.getItem('shopifyCustomerID') || null;
        if (shopifyCustomerId) {
          formData.append('attributes[shopifyCustomerID]', shopifyCustomerId);
        }

        formData.append('attributes[user_agent]', userAgent);
        formData.append('attributes[time_zone]', timeZone);
        formData.append('attributes[analytics_session_id]', analyticsSessionId);
        if (referrer) {
          formData.append('attributes[referrer]', referrer);
        }
        if (srcCode) {
          formData.append('attributes[source_code]', srcCode);
        }
        if (anonymousID) {
          formData.append('attributes[anonymous_id]', anonymousID);
        }
        if (this.cart && this.usesLegacyCartSections && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        let datazz = document.getElementById('react-jwt-all');
        let customerid = datazz?.getAttribute('data-customerid') || '';
        let shopifycustomerid = datazz?.getAttribute('data-shopifycustomer') || '';
        let pageUrl = window.location.href;

        if (pageUrl.includes('products/') && pageUrl.includes('play-subscription')) {
          formData.append('attributes[has_play_sub]', 'true');
        }

        if (pageUrl.includes('products/') && pageUrl.includes('studio-pro')) {
          formData.append('attributes[has_studio_pro]', 'true');
        }

        if (
          pageUrl.includes('products/') &&
          pageUrl.includes('play-subscription') &&
          customerid &&
          customerid !== '' &&
          shopifycustomerid &&
          shopifycustomerid !== ''
        ) {
          formData.append('properties[_fcID]', customerid);
          formData.append('properties[_shopifyCustomerID]', shopifycustomerid);
          formData.append('properties[_playSub]', 'true');
        }

        if (
          pageUrl.includes('products/') &&
          pageUrl.includes('studio-pro') &&
          customerid &&
          customerid !== '' &&
          shopifycustomerid &&
          shopifycustomerid !== ''
        ) {
          formData.append('properties[_fcID]', customerid);
          formData.append('properties[_shopifyCustomerID]', shopifycustomerid);
          formData.append('properties[_studioPro]', 'true');
        }

        const mainProduct = document.querySelector('.product-main');
        if (mainProduct) {
          const variantIdBackPre = mainProduct?.querySelector('.product-variant-id');
          const jsonElBackPre = document.getElementById('variant-backpreorder-data');

          if (variantIdBackPre && variantIdBackPre.value && jsonElBackPre) {
            let variantDataBackPre;
            try {
              variantDataBackPre = JSON.parse(jsonElBackPre.textContent);
            } catch (e) {
              console.error('Error parsing JSON:', e);
            }

            if (variantDataBackPre) {
              const metafieldsBackPre = variantDataBackPre[variantIdBackPre.value];
              if (metafieldsBackPre) {
                const backOrder = metafieldsBackPre?.backorder;
                const preOrder = metafieldsBackPre?.preorder;
                const madeToOrder = metafieldsBackPre?.made_to_order;
                const isMadeToOrder = madeToOrder === true || madeToOrder == 'true';
                const backOrderDate = metafieldsBackPre?.backorder_date;
                const preOrderDate = metafieldsBackPre?.preorder_date;
                const backOrderDateDate = metafieldsBackPre?.backorder_available_date;
                const preOrderDateDate = metafieldsBackPre?.preorder_available_date;
                const available = metafieldsBackPre?.available;
                const backorderProperties = metafieldsBackPre?.backorder_properties;
                const preorderProperties = metafieldsBackPre?.preorder_properties;
                const backorderLabel = metafieldsBackPre?.backorder_label;
                const preorderLabel = metafieldsBackPre?.preorder_label;
                const preorderLineValue = preOrderDateDate || preOrderDate || '';

                if (available && available === 'true') {
                  if (backOrder && backOrder === 'true') {
                    if (!formData.has('properties[_backOrder]')) {
                      formData.append('properties[_backOrder]', 'true');
                    }
                    if (!formData.has('properties[_backOrderDate]')) {
                      formData.append('properties[_backOrderDate]', backOrderDateDate);
                    }
                    if (backorderLabel && !formData.has('properties[_backOrderLabel]')) {
                      formData.append('properties[_backOrderLabel]', backorderLabel);
                    }
                    if (backorderProperties && !formData.has(backorderProperties)) {
                      formData.append(backorderProperties, backOrderDateDate);
                    }
                  } else if ((preOrder && preOrder === 'true') || isMadeToOrder) {
                    if (!formData.has('properties[_preOrder]')) {
                      formData.append('properties[_preOrder]', 'true');
                    }
                    if (!formData.has('properties[_preOrderDate]')) {
                      formData.append('properties[_preOrderDate]', preorderLineValue);
                    }
                    if (preorderLabel && !formData.has('properties[_preOrderLabel]')) {
                      formData.append('properties[_preOrderLabel]', preorderLabel);
                    }
                    if (preorderProperties && !formData.has(preorderProperties)) {
                      formData.append(preorderProperties, preorderLineValue);
                    }
                  }
                }
              }
            }
          }
        }

        config.body = formData;

        let additional_items = this.form.querySelectorAll('.additional-item-data');
        if (additional_items.length) {
          //We have additional items to add

          let form_data_object = Object.fromEntries(formData.entries());

          form_data_object.items = [
            {
              id: form_data_object.id,
              quantity: form_data_object.quantity
            }
          ];
          if (form_data_object.selling_plan) {
            form_data_object.items[0].selling_plan = form_data_object.selling_plan;
            delete form_data_object.selling_plan;
          }
          delete form_data_object.id;
          delete form_data_object.quantity;

          additional_items.forEach(item => {
            let item_data = JSON.parse(item.value);
            form_data_object.items.push(item_data);
            delete form_data_object[item.name];
          });

          config.body = JSON.stringify(form_data_object);
          config.headers['Content-Type'] = 'application/json';
        }

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart && this.usesLegacyCartSections) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response
              });
            this.error = false;
            const renderCartInterface = () => {
              if (this.cart && this.usesLegacyCartSections) {
                this.cart.renderContents(response);
              } else if (
                !this.usesLegacyCartSections &&
                typeof window !== 'undefined' &&
                typeof window.toggleCartDrawer === 'function'
              ) {
                window.toggleCartDrawer({ open: true, cartData: response });
              }
            };

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    renderCartInterface();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              renderCartInterface();
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        // cache the wrappers
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        // normalize non-string errors into a comma-separated string
        if (errorMessage && typeof errorMessage !== 'string') {
          if (Array.isArray(errorMessage)) {
            errorMessage = errorMessage.join(', ');
          } else if (typeof errorMessage === 'object') {
            // object of { field: [msgs...] } or similar
            errorMessage = Object.values(errorMessage)
              .map(val => (Array.isArray(val) ? val.join(', ') : String(val)))
              .join(', ');
          } else {
            errorMessage = String(errorMessage);
          }
        }

        // show or hide the wrapper
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
